import React, { useContext } from "react";
import LandingHeader from "../components/LandingHeader";
import LandingHero from "../components/LandingHero";
import { AuthContext } from "../providers/AuthProvider";
import Loader from "../components/Loader";
import SocialNetworks from "../components/SocialNetworks";

const Index = () => {
  const { loading } = useContext(AuthContext);

  return loading ? (
    <Loader text="" />
  ) : (
    <>
      <LandingHeader />
      <LandingHero />
      <SocialNetworks />
    </>
  );
};

export default Index;
